module.exports = __webpack_public_path__ + "img/queenElizabeth.2d1c3252.webp";